<template>
	<div class="">
		<el-row v-for="(item, index) in data" :key="index">
			<company-mail-item v-model="dataCopy[index]" v-on="$listeners"></company-mail-item>
		</el-row>
	</div>
</template>

<script>
import companyMailItem from './companyMailItem';
export default {
	props: {
		value: {
			type: [Array, Object],
			require: true,
		},
	},
	components: {
		companyMailItem,
	},
	data() {
		return {
			data: [],
			dataCopy: [],
		};
	},
	watch: {
		value: {
			handler(val) {
				this.data = _.cloneDeep(val);
				if (this.data.length > 0) {
					this.data.forEach(item => {
						if (!Object.prototype.hasOwnProperty.call(item, 'handChanged'))
							this.$set(item, 'handChanged', false); //标记手动添加的邮箱有没有改动
						if (!Object.prototype.hasOwnProperty.call(item, 'checkStatus'))
							this.$set(item, 'checkStatus', 1); //验证状态 1 未验证 2通过 3 失败
						if (item.emailType == 2 && item.flagOpen) {
							if (!Object.prototype.hasOwnProperty.call(item, 'email'))
								this.$set(item, 'email', item.mailbox);
						} else {
							if (!Object.prototype.hasOwnProperty.call(item, 'email'))
								this.$set(item, 'email', '');
						}
					});
				}
				this.dataCopy = this.data.map(item => {
					return item;
				});
				this.$emit('on-data', this.data);
			},
			deep: true,
			immediate: true,
		},
		dataCopy: {
			handler(val) {
				this.$emit('input', val);
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped></style>
